export default {
    BladeModel:"bladeModel",
    GaDrawing:"gaDrawing",
    OctaveBand:"octaveBand",
    Hub:"hub",
}